import React from "react";
import "./Footer.css";

const Footer = () => {
    return <footer>Made with ❤️ By Achraf Eddiba</footer>;
};

export default Footer;
